import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2026 semantics GmbH
//  Purpose   : InView Transition component
// =============================================================================
// ---Third-party imports
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
// ---Framework imports
import { log } from 'uix/logging';
import { useInView } from 'uix/hooks';
// ---Local imports
import S from './transition.css';
export const InViewTransition = ({ children, type = '', duration = 2, threshold = 0.2, className, onInViewChange, style: addStyle })=>{
    if (!type && !onInViewChange && !className && !addStyle) {
        return children;
    }
    let [isVisible, setIsVisible] = useState(false);
    let [ref, inView, entry] = useInView({
        triggerOnce: false,
        rootMargin: onInViewChange || type ? !isVisible ? `0px 0px -${threshold * 100}% 0px` : '0px' : '0px'
    });
    useEffect(()=>{
        if (onInViewChange && entry) {
            const nextVisible = entry.isIntersecting;
            setIsVisible(nextVisible);
            onInViewChange(nextVisible);
        } else if (type && entry) {
            setIsVisible(entry.isIntersecting);
        }
    }, [
        entry,
        onInViewChange,
        type
    ]);
    if (!type) {
        return /*#__PURE__*/ _jsx("div", {
            ref: ref,
            style: addStyle,
            className: className,
            children: children
        });
    }
    let style = {
        '--transition-duration': `${duration}s`,
        ...addStyle
    };
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        style: style,
        className: clsx(S.inViewTransition, isVisible && S.visible, S[type], className),
        children: children
    });
};
